import React from 'react'
import { useTranslation } from 'react-i18next'
import { Notification } from 'is24-corecss'

export interface PictureCountStatusMessageProps {
  pictureCount: number
}

export const PictureCountStatusMessage: React.FC<PictureCountStatusMessageProps> = ({ pictureCount }) => {
  const { t } = useTranslation()

  if (pictureCount === 0) {
    return null
  }

  const message =
    pictureCount <= 2
      ? t('wizard.screen.multimedia.webview.modal.pictureCountInfo.lessEqualTwo')
      : t('wizard.screen.multimedia.webview.modal.pictureCountInfo.moreThanTwo')

  return <Notification title={''} message={message} type={'info'} variant={'flat'} />
}
